import { em } from 'polished'
import styled from 'styled-components'

import ScrollToMe from 'components/ScrollToMe'

export const FormBlock = styled.div`
  width: 100%;
  height: ${em(200)};
  margin: 0 auto;

  ${p => p.theme.mq.upThreshold(639)} {
    width: ${em(600)};
    height: ${em(260)};
  }
`

export const TextBox = styled.div`
  margin-bottom: ${em(40)};
  max-width: ${em(700)};
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`

export const ButtonOrderBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: ${em(40)};
  ${p => p.theme.mq.upMd} {
    align-items: center;
    flex-direction: row;
    & .btn-rus-wrapper{
      display: block !important;
    }
    > div {
      width: 100%
    }
    > div button {
      width: 80%;
      margin-right: ${em(40)};
    }
  }
  > div {
    display: flex;
  }
  > div button {
    flex-grow: 1;
  }
`

export const OfferErrorBox = styled.div`
  display: flex;
  align-items: center;
  color: ${p => p.theme.colors.pink};
  margin-top: ${em(16)};
  justify-content: center;
  line-height: normal;

  > span {
    text-align: center;
  }

  ${p => p.theme.mq.upMd} {
    margin-top: 0;
    justify-content: flex-start;
    max-width: 50%;
    align-items: flex-start;
    > span {
      text-align: left;
    }
  }
`

export const HintIconWrapper = styled.div`
  width: ${em(40)};
  height: ${em(40)};
  margin-right: ${em(16)};
  display: none;
  ${p => p.theme.mq.upMd} {
    display: inline-block;
  }
`

export const ButtonBox = styled.div`
  display: flex;
  justify-content: center;

  & .btn-cart--mobile {
    width: ${em(260)};
  }

  ${p => p.theme.mq.upMd} {
    display: block;

    & .btn-cart--mobile {
      width: auto;
    }
  }
`

export const Indent = styled.div`
  padding-bottom: ${em(15)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
    padding-left: ${em(15)};
    padding-right: ${em(15)};
  }
`

export const PaymentIconsWrapper = styled.div`
  padding-bottom: ${em(20)};
  text-align: center;
`

export const ButtonsWrapper = styled.div`
  align-items: center;

  ${p => p.theme.mq.upMd} {
    display: flex;
    width: ${em(300)};
    margin-left: auto;
    margin-right: auto;
  }
`

export const ScrollToMeStyled = styled(ScrollToMe)`
  margin-top: -${p => p.theme.indents.inputBottomIndent};

  height: ${p => p.theme.indents.inputBottomIndent};
`
